import { render, staticRenderFns } from "./ConsuntiviDG.vue?vue&type=template&id=63ec1714&scoped=true&"
import script from "./ConsuntiviDG.vue?vue&type=script&lang=js&"
export * from "./ConsuntiviDG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ec1714",
  null
  
)

export default component.exports